module.exports = __webpack_public_path__ + "static/P3-96d3b3d0d0bf1c6d92fcf20f8142cf59.jpeg";